import { updateUser } from "../../api/UserUpdate";
import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import UserCacheName from "../../utils/UserCacheName";

export function useUpdateUser(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      toast.success("User updated successfully!");
      queryClient.invalidateQueries(UserCacheName.getUserList());
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage);
    },
  });
}
